export const notificationKeys = {
  base: () => ["notifications"],
  unread: () => [...notificationKeys.base(), "unread"],
  systemList: () => [...notificationKeys.base(), "systemList"],
  list: () => [...notificationKeys.base(), "list"],
  unreadList: () => [...notificationKeys.base(), "unreadList"],
};
